<template>
  <div class="code-demo">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CodeDemo'
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.code-demo
  &:not(:only-child)
    min-width: 50%
    max-width: 50%
    margin-left: $margin
</style>
